// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";

interface RejectDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onReject: (reason?: string) => void;
}

export function RejectDialog({ open, onOpenChange, onReject }: RejectDialogProps) {
  const { t } = useTranslation("back-office");
  const [reason, setReason] = useState("");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md p-0 gap-0 overflow-hidden flex flex-col">
        <div className="p-6 flex flex-col gap-4">
          <DialogHeader>
            <DialogTitle>{t("approvals.actions.reject")}</DialogTitle>
            <DialogDescription>{t("approvals.rejectDescription")}</DialogDescription>
          </DialogHeader>
          <Textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder={t("approvals.rejectionReason")}
            rows={3}
          />
        </div>
        <DialogFooter className="mx-0 mb-0 rounded-none rounded-b-lg">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t("buttons.cancel")}
          </Button>
          <Button
            variant="destructive"
            onClick={() => {
              onReject(reason || undefined);
              setReason("");
            }}
          >
            {t("approvals.actions.reject")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
